<template>
  <div>
    <!-- 筛选 -->
    <my-search
      buttonScreen
      :order="4"
      timeScreen
      :inputArr="inputArr"
      :searchParams="searchParams"
      :[dynamicData]="2"
      @searchEvent="searchEvent"
      @addEvent="addEvent"
      @allDel="allDel"
      @allExport="allExport"
      @allImportTemplate="allImportTemplate"
    />
    <!-- 列表 -->
    <my-table
      isSelection
      :loading="loading"
      :tableData="tableData"
      :tableHeader="tableHeader"
      :pageParams="pageParams"
      @click.native="testNative"
      @handleSelectionChange="handleSelectionChange"
    />

    <!-- 分页组件 -->
    <my-pagination :childMsg="pageParams" @callFather="callFather" />

    <!-- 添加、修改组件 -->
    <my-dialog
      :isDialogShow.sync="isDialogShow"
      :operTitle="operTitle"
      :operForm="operForm"
      :operFormArr="operFormArr"
      :selectArrAdd="selectArrAdd"
      :rules="rules"
      :loading="loading"
      @submitForm="submitForm"
      @hook:mounted="doSomeThing"
    />

    <!-- 详情组件 -->
    <my-dialog-detail
      :isDialogDetailShow.sync="isDialogDetailShow"
      :operForm="operForm"
      :operFormArr="operFormArr"
      :closeDialog="closeDialog"
    />
  </div>
</template>

<script>
import _exportMethods from "@/utils/excel";
import mixins from "@/mixins/common";
import {
  tagList,
  addTag,
  editTag,
  delTag,
  allDelTag,
  tagClassList,
} from "@/network/content/tag";

export default {
  mixins: [mixins],
  provide() {
    return {
      importType: "tag",
      initData: this.getInitData,
    };
  },
  watch: {
    tableData: {
      handler(val) {
        // console.log(val);
      },
      immediate: false,
      deep: false,
    },
  },
  data() {
    return {
      tagClassList: [], //标签分类列表
      /**
       * 当前头部数据列
       * 不需要响应式的数据可以进行冻结，Vue实例不会对数据再做数据劫持(getter、setter转换),可以提高Vue渲染性能
       * 不可以向当前对象添加、更新、删除属性。如需修改可以将变量的引用替换掉
       */
      tableHeader: Object.freeze([
        {
          name: "标签名称",
          prop: "tagName",
        },
        {
          name: "标签分类",
          prop: "tagCollectionIdTrans",
        },
        {
          name: "标签简介",
          prop: "tagIntroduction",
        },
        {
          name: "标签等级",
          prop: "level",
        },
        {
          name: "创建时间",
          prop: "createTime",
        },
        {
          name: "操作",
          prop: "operation",
          operation: [
            // { name: '详情', clickFun: this.detailTag, show: true },
            { name: "编辑", clickFun: this.editTag, show: true },
            { name: "删除", clickFun: this.delTag, show: true },
          ],
        },
      ]),
      //筛选时文本框所需参数
      inputArr: [
        {
          name: "userZh",
          defaultText: "请输入标签名称",
        },
      ],
      //添加、编辑时下拉框所需参数
      selectArrAdd: [
        {
          prop: "tagCollectionId",
          label: "标签分类",
          getData: "value",
          defaultOptions: [],
        },
      ],
      //添加、编辑时文本框所需参数
      operFormArr: [
        {
          name: "tagName",
          label: "标签名称",
          defaultText: "请输入标签名称",
        },
        {
          name: "tagIntroduction",
          label: "标签简介",
          type: "textarea",
          defaultText: "请输入标签简介",
        },
        {
          name: "level",
          label: "标签等级",
          defaultText: "请输入标签等级",
        },
      ],
      //添加、编辑双向绑定值
      operForm: {
        id: "",
        tagName: "",
        tagCollectionId: "",
        tagIntroduction: "",
        level: "",
      },
      //搜索参数
      searchParams: {
        timeOptions: "",
        userZh: "",
      },
      // rules表单验证
      rules: {
        tagName: [
          {
            required: true,
            message: "请输入标签名称",
            trigger: "blur",
          },
        ],
        tagCollectionId: [
          {
            required: true,
            message: "请输入标签分类",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.getTagClassList();
  },
  methods: {
    // 初始数据
    getInitData(isSearch) {
      let { timeOptions } = this.searchParams; //日期参数
      let params = {
        data: {
          tagName: this.searchParams.userZh,
        },
        startTime: timeOptions ? timeOptions[0] : "",
        endTime: timeOptions ? timeOptions[1] : "",
        current: isSearch ? 1 : this.pageParams.currentPage,
        size: this.pageParams.pageSize,
      };
      tagList(params).then((e) => {
        this.loading = false;
        let { code, data } = e.data;
        if (code == 200) {
          this.tableData = data.records;
          this.pageParams.total = data.total;
          if (isSearch) this.pageParams.currentPage = 1;
        }
      });
    },
    getTagClassList() {
		let params = {
		  data: {
		    tagName: '',
		  },
		  startTime: '',
		  endTime: '',
		  current:'',
		  size: '',
		};
      tagClassList({params}).then((e) => {
        let { code, data, msg } = e.data;
        if (code == 200) {
          for (let v of data.records) {
            let obj = {
              value: v.id,
              label: v.name,
            };
            this.tagClassList.push(obj);
			
          }
        }
      });
    },
    // 新增
    addTag() {
      // 清空
      this.operForm = {};
      this.operTitle = true;
      this.isDialogShow = true;
    },
    //添加、编辑
    submitForm(valid) {
      if (valid) {
        //根据类型不同调用不同的操作接口
        let interType = this.operTitle ? addTag : editTag;
        let tagCollectionId = this.operForm.tagCollectionId;
        interType({ ...this.operForm, tagCollectionId }).then((e) => {
          let { code, data, msg } = e.data;
          if (code == 200) {
            this.isDialogShow = false;
            this.loading = false;
            this.getInitData();
            this.$message.success("操作成功");
          } else {
            this.$message.error("操作失败");
          }
        });
      } else {
        return false;
      }
    },
    //搜索事件
    searchEvent() {
      this.getInitData(true);
    },
    //添加事件
    addEvent() {
      this.isDialogShow = true;
      this.operTitle = true;
      this.selectArrAdd[0].defaultOptions = this.tagClassList;
      this.operForm = {}; //防止多次添加有上次添加的残留数据
    },
    //详情事件
    detailTag(item) {
      this.isDialogDetailShow = true;
      this.operForm = item;
    },
    //编辑事件
    editTag(item) {
      this.isDialogShow = true;
      this.operTitle = false;
      this.selectArrAdd[0].defaultOptions = this.tagClassList;
      this.operForm = {
        id: item.id,
        tagName: item.tagName,
        tagCollectionId: item.tagCollectionId,
        tagIntroduction: item.tagIntroduction,
        level: item.level,
      };
	  console.log(this.operForm)
    },
    //删除事件
    delTag(item) {
      this.$confirm("删除该条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        delTag(item.id).then((e) => {
          let { code, data, msg } = e.data;
          if (code == 200) {
            this.getInitData();
            this.$message.success("操作成功");
          } else {
            this.$message.error("操作失败");
          }
        });
      });
    },
    //批量删除
    allDel() {
      let data = this.selectedData;
      if (data.length == 0) {
        this.$message.warning("请选择要操作的数据！");
        return;
      }
      this.$confirm("删除所选数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let delIds = [];
        delIds = data.map((e) => e.id);
        allDelTag({
          ids: delIds,
        }).then((e) => {
          let { code, data, msg } = e.data;
          if (code == 200) {
            this.getInitData();
            this.$message.success("操作成功");
          } else {
            this.$message.error("操作失败");
          }
        });
      });
    },
    //批量导出
    allExport() {
      let timeOptions = this.searchParams.timeOptions; //日期参数
      let data = {
        data: {
          tagName: this.searchParams.textTagName,
          tagKeyword: this.searchParams.textTagKeyword,
        },
        startTime: timeOptions ? timeOptions[0] : "",
        endTime: timeOptions ? timeOptions[1] : "",
        current: this.pageParams.currentPage,
        size: this.pageParams.pageSize,
      };
      let exportParams = {
        method: "post",
        url: "/api/app/sys/tag/export/list",
        data,
      };
      _exportMethods(exportParams);
    },
    //导入模板
    allImportTemplate() {
      let importParams = {
        method: "get",
        url: "/api/app/sys/tag/export/template",
      };
      _exportMethods(importParams);
    },
    //详情函数式组件关闭弹框
    closeDialog() {
      this.isDialogDetailShow = false;
    },
    //在子组件上监听点击事件，如果不加.native的话，Vue会以为是自定义的事件，这样的话必须得在子组件发送一个emit事件触发才可以
    testNative() {
      // console.log("native click");
    },
    //在父组件里监听到子组件的生命周期 @hook:mounted="doSomething"
    doSomeThing() {
      // console.log('父组件监听到 mounted 钩子函数 ...');
    },
  },
};
</script>

<style scoped>
</style>

 
 